export default __webpack_public_path__ + "static/media/product-display-img.dead449b.png";